import { mergeSearchStringToFanFilters } from '@/utils/filter/';
import { correlateListSubscriptionChannel } from '@/utils/filter/listSubscriptionChannel';

/**
 * MASS_EDIT_FAN
 *
 * @param { object } context - Store context (state, rootstate, getters, commit, dispatch)
 */
export async function MASS_EDIT_FAN({ state }, { fanOids, filter, searchString, editData, messageList = null, tags = null }) {
    if (!state.auth.account) { return null; }
    const { promoterOid } = state.auth.account;

    // EC-4237: keep the edited set identical to the audience the user is looking at.
    const filterDecorated = mergeSearchStringToFanFilters(
      correlateListSubscriptionChannel(filter),
      searchString,
    );

    try {
      const body = {
        messageList,
        tags,
        attributes: editData,
      };
      if (fanOids) {
        body.fanOids = fanOids;
      } else {
        body.filter = filterDecorated;
      }
      await this.$axios.post(`/promoter/${promoterOid}/mass-edit-fan`, body);
    } catch (error) {
      throw error;
    }
  }
